require('@qnpm/godeye'); // eslint-disable-next-line no-underscore-dangle


window.GodEye.init({
  pageId: window.__page_id
});
export default {
  /**
   * logMsg (message: String)
   * `message` 是被操作的控件包含的一组文本。 `message`不能为空。
   */
  logMsg: function logMsg(message) {
    if (!message || typeof message !== 'string' || message.length === 0) {
      console.warn('message参数不合法');
      return;
    }

    window.GodEye.log({
      r: 'qav',
      qav: message
    });
  },

  /**
   * log (tag: String, message: String)
   * `tag` 是控件手动唯一标识，`message` 是被操作的控件包含的一组文本。 `tag`值可以为空，为空默认的r值为“qav”，`message`不能为空。
   */
  log: function log(tag, message) {
    if (!message) {
      console.warn('message参数不能为空');
      return;
    }

    if (message.length === 0) {
      console.warn('message字符串不能为空');
      return;
    }

    try {
      window.GodEye.log({
        r: 'qav',
        qav: message,
        tag: tag
      });
    } catch (e) {}
  }
};